import { createFirebaseBrowserAdapter } from './adapters/firebase.browser';
import { createFetchExchangeAdapter } from './adapters/exchange.fetch';
import { createAuthActions } from './actions';
import { startAuthEngine } from './engine/authEngine';
import { createStatusStore } from './status-store';
let singletonModule = null;
/**
 * Install the auth module. Idempotent: subsequent calls return the existing instance.
 * Call dispose() to tear down (useful for HMR).
 */
export function installAuth(deps = {}) {
    if (singletonModule)
        return singletonModule;
    const firebase = deps.firebase ?? createFirebaseBrowserAdapter();
    const exchange = deps.exchange ?? createFetchExchangeAdapter();
    const store = deps.store ?? createStatusStore();
    const engine = startAuthEngine({ firebase, exchange, store });
    const actions = createAuthActions({
        firebase,
        onAfterEmailVerified: () => engine.refreshStatus(),
    });
    const module = {
        getStatus: () => store.getStatus(),
        subscribe: (listener) => store.subscribe(listener),
        whenReady: () => engine.whenReady(),
        refreshStatus: () => engine.refreshStatus(),
        actions,
        dispose() {
            engine.dispose();
            if (singletonModule === module) {
                singletonModule = null;
            }
        },
    };
    singletonModule = module;
    return module;
}
/**
 * Returns the currently installed AuthModule. Throws if called before installAuth().
 * Used by route guards that run outside React (TanStack Router beforeLoad).
 */
export function getAuthModule() {
    if (!singletonModule) {
        throw new Error('Auth module not installed. Call installAuth() once at app bootstrap.');
    }
    return singletonModule;
}
